import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Col } from 'reactstrap';
import Calendar from '../../../Calendar/Calendar';
import events from './events';

const BigCalendar = ({ dir, setDateSelected }) => (
  <Calendar dir={dir} events={events} setDateSelected={(date) => setDateSelected(date)} />
);

BigCalendar.propTypes = {
  dir: PropTypes.string.isRequired,
};

export default BigCalendar;
